import { useState } from 'react';
import { ChevronDown, FileSpreadsheet, FileText } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

const FILE_FORMATS = [
  {
    id: 'xlsx',
    label: 'Excel workbook (.xlsx)',
    icon: FileSpreadsheet,
    iconClassName: 'text-emerald-600 dark:text-emerald-400',
  },
  {
    id: 'md',
    label: 'Markdown (.md)',
    icon: FileText,
    iconClassName: 'text-muted-foreground',
  },
];

// Export ▾ / Import ▾ on the Knowledge Base and Trigger Base pages — a button opening the file-format
// list; picking one hands its id ('xlsx' | 'md') to onPick. `hints` maps a format id to its subtitle.
function FileFormatMenu({ label, icon: Icon, busy = false, hints = {}, align = 'end', onPick }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={busy}>
          {busy ? <Spinner className="mr-2 h-4 w-4" /> : <Icon className="mr-2 h-4 w-4" />}
          {label}
          <ChevronDown className="ml-1.5 h-4 w-4 opacity-60" aria-hidden />
        </Button>
      </PopoverTrigger>
      <PopoverContent align={align} className="w-64 p-1.5">
        {FILE_FORMATS.map((fileFormat) => {
          const FormatIcon = fileFormat.icon;
          return (
            <button
              key={fileFormat.id}
              type="button"
              onClick={() => {
                setOpen(false);
                onPick(fileFormat.id);
              }}
              className="flex w-full items-start gap-2.5 rounded-md px-2 py-1.5 text-left text-[13px] hover:bg-accent"
            >
              <FormatIcon className={cn('mt-0.5 h-4 w-4 shrink-0', fileFormat.iconClassName)} aria-hidden />
              <span className="min-w-0">
                <span className="block font-medium">{fileFormat.label}</span>
                {hints[fileFormat.id] ? (
                  <span className="block text-[11px] text-muted-foreground">{hints[fileFormat.id]}</span>
                ) : null}
              </span>
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}

export default FileFormatMenu;
